<form [formGroup]="form">
  <mat-form-field floatLabel="always" class="mat-border-none" *ngIf="options && options.length">
    <mat-label class="req" [innerHtml]="label ? label : ''" [title]="label">
    </mat-label>
    <mat-radio-group [formControlName]="controlName">
      <mat-radio-button *ngFor="let item of options" [value]="item.id">{{item.title}}</mat-radio-button>
    </mat-radio-group>
    <input matInput class="d-none">
    <div *ngIf="form.get([controlName]).touched &&form.get([controlName]).hasError('required')" class="error">
      Field is mandatory
    </div>
  </mat-form-field>
</form>
